<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiBriefcasePlus } from "@mdi/js"
export default {
  name: "WorkdayIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
        path: mdiBriefcasePlus,
    }
  }
}
</script>
